package com.essntl.features.organization.ui.organizationdetails

interface OrganizationDetailsNavigation {
    data class EditContact(val id: String) : OrganizationDetailsNavigation
    data object Toggle : OrganizationDetailsNavigation
    data class EditProposal(val proposalId: String) : OrganizationDetailsNavigation
    data class EditItinerary(val itineraryId: String) : OrganizationDetailsNavigation
}